import type { Affiliate, Offer, OfferCategory } from 'models/offer';

import { OffersActionTypes, type TOffersActions } from './actions';

interface IOffersState {
  offers: Offer[] | undefined;
  currentOffer: Offer | undefined;
  categories: OfferCategory[] | undefined;
  affiliates: Affiliate[] | undefined;
  countries: ICountry[] | undefined;
}

export interface ICountry {
  id: number;
  countryCode: string;
  currency: string;
  amount: string;
  location?: string;
  webPrice: string;
  webPriceCurrency: string;
  warranty?: number;
  isActive: boolean;
}

const initialState: IOffersState = {
  offers: [],
  currentOffer: undefined,
  categories: [],
  affiliates: [],
  countries: [],
};

export const offersReducer = (state = initialState, action: TOffersActions): IOffersState => {
  switch (action.type) {
    case OffersActionTypes.GET_OFFERS_REQUEST:
      return { ...state, offers: action.payload };
    case OffersActionTypes.SET_CURRENT_OFFER:
      const offer = (state.offers || []).find((el) => el.id === action.payload) ?? undefined;
      return { ...state, currentOffer: offer, countries: offer?.payouts };
    case OffersActionTypes.UPDATE_CURRENT_OFFER:
      return { ...state, currentOffer: { ...state.currentOffer, ...action.payload } };
    case OffersActionTypes.SET_CURRENT_CATEGORIES:
      return { ...state, categories: action.payload };
    case OffersActionTypes.SET_CURRENT_AFFILIATES:
      return { ...state, affiliates: action.payload };
    case OffersActionTypes.SET_CURRENT_COUNTRIES:
      const currentCountries = state.currentOffer?.payouts;
      return { ...state, countries: currentCountries };
    case OffersActionTypes.UPDATE_CURRENT_COUNTRY_WARRANTY:
      let warranties: ICountry[] = [];
      state.countries?.forEach((device, index) => {
        warranties[index] = { ...device };
      });
      for (let i = 0; i < warranties.length!; i++) {
        if (warranties[i].id === action.payload.id) {
          warranties[i].warranty = action.payload.warranty;
        }
      }
      return { ...state, countries: warranties };
    case OffersActionTypes.UPDATE_CURRENT_COUNTRY:
      let countries: ICountry[] = [];
      state.countries?.forEach((device, index) => {
        countries[index] = { ...device };
      });
      if (countries) {
        for (let i = 0; i < countries.length!; i++) {
          if (countries[i].id === action.payload.id) {
            countries[i].id = action.payload.id;
            countries[i].countryCode = action.payload.countryCode;
            countries[i].currency = action.payload.currency;
            countries[i].amount = action.payload.amount;
            countries[i].webPrice = action.payload.webPrice;
            countries[i].webPriceCurrency = action.payload.webPriceCurrency;
            countries[i].isActive = action.payload.isActive;
          }
        }
      }
      return { ...state, countries: countries };
    default:
      return state;
  }
};
